import { createFeatureManager } from '../../libs/feature-management/feature-management.mjs';
import { getUserId } from '../user-id-provider';
import { googleTagManager } from '../tracking';
import { getPersistentItem, setPersistentItem } from '../persistence';

const trackExperiment = (key, variant) => {
    const activatedExperiments = getPersistentItem('activated_experiments') || {};
    activatedExperiments[key] = variant;
    setPersistentItem('activated_experiments', activatedExperiments);

    googleTagManager.trackEventWithName('jetfm_experiment', {
        customData: {
            experimentId: key,
            variant: variant,
        },
    });
};

const featureManagement = createFeatureManager({
    keyPrefix: window.jetfm.keyPrefix,
    cdn: {
        scope: window.jetfm.scope,
        environment: window.jetfm.environment,
        key: window.jetfm.key,
        poll: false,
    },
    getContext: () => ({
        restrictionsProviders: new Map().set('Country', () => window.country.code.toUpperCase()),
        anonUserId: getUserId(),
    }),
    onTrack: (key, variant) => trackExperiment(key, variant),
});

const getFeature = async (key, type) => {
    const getFeatureValue = (key, type) => {
        switch (type) {
            case Boolean:
                return featureManagement.getBooleanValue(key);
            case Number:
                return featureManagement.getIntegerValue(key);
            case String:
                return featureManagement.getStringValue(key);
        }
    };
    try {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has(key)) {
            const variant = type(searchParams.get(key));

            console.info(`Forced: ${key} => ${variant}`);

            trackExperiment(key, variant);

            return new Promise((resolve) => resolve(variant));
        }
        await featureManagement.loadFromCdn();

        return getFeatureValue(key, type);
    } catch (error) {
        // TODO: Add logging code and fallback value.
        console.error(error);
    }
};

export const getActivatedExperiments = () => {
    return Object.entries(getPersistentItem('activated_experiments') || {})
        .map(([key, variant]) => `${key}=${variant}`)
        .join(';');
};

/**
 * @returns {Promise<'control'| 'variant'>}
 */
export const getAATestFeatureValue = () => {
    return getFeature('fm_scoober_recruitment_aa_test_flag', String);
};
